var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-458.098 -432.785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.3,448.83H460.737a.64.64,0,0,1-.639-.639v-5.214a3.2,3.2,0,0,1,3.193-3.192h37.46a3.2,3.2,0,0,1,3.193,3.192v5.214A.64.64,0,0,1,503.3,448.83Zm-41.929-1.278h41.291v-4.576a1.918,1.918,0,0,0-1.916-1.916h-37.46a1.917,1.917,0,0,0-1.915,1.916Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.277,
    height: 5.746,
    transform: "translate(468.187 445.318)",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.277,
    height: 5.746,
    transform: "translate(494.579 445.318)",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.3,474.264h-7.449a.639.639,0,0,1-.452-1.09l7.45-7.449a.639.639,0,0,1,1.09.452v7.449A.64.64,0,0,1,503.3,474.264Zm-5.908-1.277h5.269v-5.269Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.856,474.264H460.738a.639.639,0,0,1-.639-.638V448.192a.64.64,0,0,1,.639-.639h42.568a.639.639,0,0,1,.638.639v17.985a.64.64,0,0,1-.187.452l-7.449,7.449A.645.645,0,0,1,495.856,474.264Zm-34.48-1.277h34.215l7.075-7.075V448.83H461.375v24.157Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.986,457.125c0,3.979-4.469,5.412-4.488,8.448v.207h4.337v1.339h-5.789v-1.131c0-4.262,4.469-5.091,4.469-8.806,0-1.357-.453-2.074-1.546-2.074-1.074,0-1.546.774-1.546,1.942v1.169h-1.377v-1.075c0-2.018.924-3.357,2.96-3.357C479.062,453.788,479.986,455.108,479.986,457.125Z",
    fill: "#3a2e83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.285,459.294a2.125,2.125,0,0,1,1.961-1.093c1.7,0,2.451,1.245,2.451,3.13v2.583c0,2.018-.962,3.337-2.979,3.337s-2.96-1.32-2.96-3.337v-.886h1.376v.98c0,1.189.491,1.9,1.546,1.9s1.547-.717,1.547-1.9v-2.564c0-1.188-.491-1.9-1.547-1.9a1.423,1.423,0,0,0-1.49,1.414v.3h-1.376l.358-7.335h5.2v1.319h-3.884Z",
    fill: "#3a2e83"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.eee8498eaa5d29e094cf320e676e2d1d.svg";
export { ForwardRef as ReactComponent };